<app-full-page-message
    *ngIf="businessId && businessId.length > 5 && !localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)" />
<div
    *ngIf="!businessId || businessId.length < 5 || localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)">
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.qr_label_gen && templates">
        <div class="banner center" style="max-width:800px;">
            <div class="row row_header freeze_height">
                <div class="col-md-6" style="text-align: left;">
                    <i class="material-icons on_language_changed" (click)="onLoad()">refresh</i>
                    <i class="material-icons" (click)="onAction(1)"
                        title="{{localService.languageContent.common.add}}">note_add</i>
                    <span style="margin-left: 5px;">{{localService.languageContent.qr_label_gen.templates}}</span>
                </div>
                <div class="col-md-6" style="text-align: right;">
                    <label style="font-weight: normal; margin-left: 15px;">
                        <input type="checkbox" [(ngModel)]="isShowDeleted" (change)="onLoad()" />
                        <span class="normal_color">{{localService.languageContent.qr_label_gen.show_deleted}}</span>
                    </label>
                </div>
            </div>
            <div class="custom_rows_body" *ngIf="templates" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
                <div class="row styled_row" *ngFor="let item of templates">
                    <div class="col-1">
                        <i class="material-icons icon_adjust" (click)="onAction(2,item.key)" [ngClass]="{
                    'delete_icon': item.v7 =='1'
                    }">
                            {{item.v7 =='1' ? 'cancel' : 'restore'}}
                        </i>
                    </div>
                    <div class="col-10">
                        <span class="button" (click)="onAction(1,item.key)">{{item.v2}}</span>
                    </div>
                    <div class="col-1">
                        <button class="button_icon button_icon_color icon_adjust" *ngIf="!isShowDeleted"
                            (click)="onAction(3,item.key)">file_upload</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="businessId && businessId.length > 5">
    <span style="display: none;">
        <button class="after_access_check" (click)="onInitiate()">After Access Check</button>
    </span>
</div>